const CustConfig = window.cConfig;

const theme = {
  primaryColor: CustConfig.color || 'rgb(48, 95, 156)',
};

export default theme;
